const OVERRIDES_KEY = "modfed-overrides";

function getOverrides() {
  try {
    return JSON.parse(localStorage.getItem(OVERRIDES_KEY) || "{}");
  } catch {
    return {};
  }
}

function saveOverrides(overrides) {
  const cleaned = Object.fromEntries(
    Object.entries(overrides).filter(([, v]) => v),
  );
  if (Object.keys(cleaned).length === 0) {
    localStorage.removeItem(OVERRIDES_KEY);
  } else {
    localStorage.setItem(OVERRIDES_KEY, JSON.stringify(cleaned));
  }
}

function injectStyles() {
  if (document.getElementById("modfed-devtools-styles")) return;
  const style = document.createElement("style");
  style.id = "modfed-devtools-styles";
  style.textContent = `
    .modfed-devtools-trigger {
      position: fixed;
      bottom: 10px;
      right: 10px;
      z-index: 99999;
      background: #1a1a2e;
      color: #00d4ff;
      border: 1px solid #00d4ff;
      border-radius: 4px;
      padding: 6px 10px;
      font-family: monospace;
      font-size: 13px;
      cursor: pointer;
      opacity: 0.8;
      transition: opacity 0.2s;
    }
    .modfed-devtools-trigger:hover {
      opacity: 1;
    }
    .modfed-devtools-panel {
      display: none;
      position: fixed;
      bottom: 45px;
      right: 10px;
      z-index: 99999;
      width: 520px;
      max-height: 70vh;
      overflow-y: auto;
      background: #1a1a2e;
      color: #e0e0e0;
      border: 1px solid #00d4ff;
      border-radius: 6px;
      font-family: monospace;
      font-size: 12px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.5);
    }
    .modfed-devtools-panel.open {
      display: block;
    }
    .modfed-devtools-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 14px;
      background: #16213e;
      border-bottom: 1px solid #333;
      font-size: 13px;
      font-weight: bold;
      color: #00d4ff;
    }
    .modfed-devtools-close {
      background: none;
      border: none;
      color: #888;
      font-size: 18px;
      cursor: pointer;
      padding: 0 4px;
    }
    .modfed-devtools-close:hover {
      color: #fff;
    }
    .modfed-devtools-row {
      padding: 10px 14px;
      border-bottom: 1px solid #2a2a3e;
    }
    .modfed-devtools-row-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 6px;
    }
    .modfed-devtools-name {
      font-weight: bold;
      color: #fff;
    }
    .modfed-devtools-badge {
      font-size: 10px;
      padding: 1px 6px;
      border-radius: 3px;
      background: #2a4a2a;
      color: #4caf50;
    }
    .modfed-devtools-badge.overridden {
      background: #4a3a1a;
      color: #ffb74d;
    }
    .modfed-devtools-url-row {
      display: flex;
      gap: 6px;
      align-items: center;
    }
    .modfed-devtools-input {
      flex: 1;
      background: #0d1117;
      color: #e0e0e0;
      border: 1px solid #333;
      border-radius: 3px;
      padding: 4px 8px;
      font-family: monospace;
      font-size: 11px;
    }
    .modfed-devtools-input.overridden {
      border-color: #ffb74d;
    }
    .modfed-devtools-input:focus {
      outline: none;
      border-color: #00d4ff;
    }
    .modfed-devtools-reset-btn {
      background: none;
      border: 1px solid #555;
      color: #888;
      border-radius: 3px;
      padding: 3px 8px;
      cursor: pointer;
      font-size: 11px;
      white-space: nowrap;
    }
    .modfed-devtools-reset-btn:hover {
      border-color: #ff5252;
      color: #ff5252;
    }
    .modfed-devtools-footer {
      display: flex;
      justify-content: space-between;
      padding: 10px 14px;
      background: #16213e;
      border-top: 1px solid #333;
    }
    .modfed-devtools-apply-btn {
      background: #00d4ff;
      color: #1a1a2e;
      border: none;
      border-radius: 4px;
      padding: 6px 16px;
      font-weight: bold;
      font-size: 12px;
      cursor: pointer;
    }
    .modfed-devtools-apply-btn:hover {
      background: #00b8d4;
    }
    .modfed-devtools-reset-all-btn {
      background: none;
      border: 1px solid #555;
      color: #888;
      border-radius: 4px;
      padding: 6px 12px;
      font-size: 12px;
      cursor: pointer;
    }
    .modfed-devtools-reset-all-btn:hover {
      border-color: #ff5252;
      color: #ff5252;
    }
    .modfed-devtools-default-url {
      font-size: 10px;
      color: #666;
      margin-top: 3px;
      word-break: break-all;
    }
  `;
  document.head.appendChild(style);
}

function buildUI(remotesMeta, defaults) {
  const overrides = getOverrides();
  const inputs = {};

  injectStyles();

  const trigger = document.createElement("button");
  trigger.className = "modfed-devtools-trigger";
  trigger.textContent = "{ } MF";

  const panel = document.createElement("div");
  panel.className = "modfed-devtools-panel";

  const header = document.createElement("div");
  header.className = "modfed-devtools-header";
  const title = document.createElement("span");
  title.textContent = "Module Federation Devtools";
  const closeBtn = document.createElement("button");
  closeBtn.className = "modfed-devtools-close";
  closeBtn.textContent = "×";
  header.appendChild(title);
  header.appendChild(closeBtn);
  panel.appendChild(header);

  const list = document.createElement("div");

  remotesMeta.forEach(({ name }) => {
    const defaultUrl = defaults[name] || "";
    const overrideUrl = overrides[name] || "";
    const isOverridden = !!overrideUrl;

    const row = document.createElement("div");
    row.className = "modfed-devtools-row";

    const rowHeader = document.createElement("div");
    rowHeader.className = "modfed-devtools-row-header";
    const nameEl = document.createElement("span");
    nameEl.className = "modfed-devtools-name";
    nameEl.textContent = name;
    rowHeader.appendChild(nameEl);

    const badge = document.createElement("span");
    badge.className =
      "modfed-devtools-badge" + (isOverridden ? " overridden" : "");
    badge.textContent = isOverridden ? "overridden" : "default";
    rowHeader.appendChild(badge);
    row.appendChild(rowHeader);

    const urlRow = document.createElement("div");
    urlRow.className = "modfed-devtools-url-row";
    const input = document.createElement("input");
    input.className =
      "modfed-devtools-input" + (isOverridden ? " overridden" : "");
    input.value = isOverridden ? overrideUrl : defaultUrl;
    input.placeholder = defaultUrl;
    inputs[name] = { input, defaultUrl };
    urlRow.appendChild(input);

    if (isOverridden) {
      const resetBtn = document.createElement("button");
      resetBtn.className = "modfed-devtools-reset-btn";
      resetBtn.textContent = "Reset";
      resetBtn.addEventListener("click", () => {
        input.value = defaultUrl;
        input.classList.remove("overridden");
        badge.classList.remove("overridden");
        badge.textContent = "default";
        resetBtn.remove();
        const current = getOverrides();
        delete current[name];
        saveOverrides(current);
      });
      urlRow.appendChild(resetBtn);
    }

    row.appendChild(urlRow);

    if (isOverridden) {
      const defaultLine = document.createElement("div");
      defaultLine.className = "modfed-devtools-default-url";
      defaultLine.textContent = "Default: " + defaultUrl;
      row.appendChild(defaultLine);
    }

    list.appendChild(row);
  });

  panel.appendChild(list);

  const footer = document.createElement("div");
  footer.className = "modfed-devtools-footer";

  const resetAllBtn = document.createElement("button");
  resetAllBtn.className = "modfed-devtools-reset-all-btn";
  resetAllBtn.textContent = "Reset All";
  resetAllBtn.addEventListener("click", () => {
    localStorage.removeItem(OVERRIDES_KEY);
    location.reload();
  });

  const applyBtn = document.createElement("button");
  applyBtn.className = "modfed-devtools-apply-btn";
  applyBtn.textContent = "Apply & Reload";
  applyBtn.addEventListener("click", () => {
    const newOverrides = {};
    for (const [name, { input, defaultUrl }] of Object.entries(inputs)) {
      const val = input.value.trim();
      if (val && val !== defaultUrl) {
        newOverrides[name] = val;
      }
    }
    saveOverrides(newOverrides);
    location.reload();
  });

  footer.appendChild(resetAllBtn);
  footer.appendChild(applyBtn);
  panel.appendChild(footer);

  trigger.addEventListener("click", () => {
    panel.classList.toggle("open");
  });

  closeBtn.addEventListener("click", () => {
    panel.classList.remove("open");
  });

  document.body.appendChild(panel);
  document.body.appendChild(trigger);
}

export function initModfedDevtools(remotesMeta, defaults, stage) {
  const disabledStages = ["prod"];
  if (
    disabledStages.includes(stage) ||
    localStorage.getItem("devtools") !== "true"
  ) {
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () =>
      buildUI(remotesMeta, defaults),
    );
  } else {
    buildUI(remotesMeta, defaults);
  }
}
